import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Define targets: the dropdown and all conditional field sections
  static targets = [ "select", "fields" ]

  // This method runs when the controller first connects to the element
  connect() {
    // console.log("Payment Fields Controller connected!");
    // Ensure the correct fields are shown based on the initial dropdown value
    this.toggleFields();
  }

  // This method is triggered by the 'change' action on the select target
  toggleFields() {
    // Get the currently selected value from the dropdown
    const selectedMethod = this.selectTarget.value;
    // console.log("Selected payment method:", selectedMethod);

    // Loop through all elements marked as 'fields' targets
    this.fieldsTargets.forEach(element => {
      // Check if the element's 'data-payment-method' matches the selected value
      const isMatchingMethod = element.dataset.paymentMethod === selectedMethod;
      // console.log(`Checking field set: ${element.dataset.paymentMethod}, Match: ${isMatchingMethod}`);

      // Toggle the 'hidden' class based on whether it matches
      // If it matches (isMatchingMethod is true), we want to REMOVE 'hidden'.
      // If it doesn't match (isMatchingMethod is false), we want to ADD 'hidden'.
      element.classList.toggle('hidden', !isMatchingMethod);
    });
  }
}
